import React from 'react';
import { SchematicShell, Line } from './SchematicPrimitives';

const IN = 0.0254;
const PANEL_THICK = 0.5 * IN;
const DRAWER_GAP = 0.25 * IN;
const NUM_DRAWERS = 2;
const PULL_W = 3 * IN;
const ARC_RISE = 0.75 * IN;

export function DormStackableDrawersSchematic({
  widthMeters: width,
  heightMeters: height,
  depthMeters: depth,
  view = 'front',
  strokeColor,
  strokeWidth,
}) {
  if (view === 'left' || view === 'right') {
    return (
      <SchematicShell
        width={depth}
        height={height}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      >
        <g
          transform={
            view === 'right'
              ? `scale(-1, 1) translate(${-depth}, 0)`
              : undefined
          }
        >
          <DrawersSide
            depth={depth}
            height={height}
            strokeColor={strokeColor}
            strokeWidth={strokeWidth}
          />
        </g>
      </SchematicShell>
    );
  }

  const bodyTop = PANEL_THICK;
  const bodyBottom = height - PANEL_THICK;
  const innerH = bodyBottom - bodyTop;
  const drawerH = (innerH - (NUM_DRAWERS - 1) * DRAWER_GAP) / NUM_DRAWERS;

  return (
    <SchematicShell
      width={width}
      height={height}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
    >
      {/* Top band */}
      <Line
        x1={0}
        y1={bodyTop}
        x2={width}
        y2={bodyTop}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      {/* Bottom band */}
      <Line
        x1={0}
        y1={bodyBottom}
        x2={width}
        y2={bodyBottom}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      {/* Drawer gap lines */}
      {Array.from({ length: NUM_DRAWERS - 1 }, (_, g) => {
        const y = bodyTop + (g + 1) * drawerH + g * DRAWER_GAP + DRAWER_GAP / 2;
        return (
          <Line
            key={`gap-${g}`}
            x1={0}
            y1={y}
            x2={width}
            y2={y}
            strokeColor={strokeColor}
            strokeWidth={strokeWidth}
          />
        );
      })}
      {/* Arc pulls near top of each drawer */}
      {Array.from({ length: NUM_DRAWERS }, (_, d) => {
        const drawerTop = bodyTop + d * (drawerH + DRAWER_GAP);
        const pullY = drawerTop + 1.5 * IN;
        const x1 = (width - PULL_W) / 2;
        const x2 = (width + PULL_W) / 2;
        const cx = width / 2;
        return (
          <path
            key={`pull-${d}`}
            d={`M ${x1} ${pullY} Q ${cx} ${pullY - ARC_RISE} ${x2} ${pullY}`}
            fill="none"
            stroke={strokeColor}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            vectorEffect="non-scaling-stroke"
          />
        );
      })}
    </SchematicShell>
  );
}

function DrawersSide({ depth, height, strokeColor, strokeWidth }) {
  const bodyTop = PANEL_THICK;
  const bodyBottom = height - PANEL_THICK;

  return (
    <g>
      {/* Top band */}
      <Line
        x1={0}
        y1={bodyTop}
        x2={depth}
        y2={bodyTop}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      {/* Bottom band */}
      <Line
        x1={0}
        y1={bodyBottom}
        x2={depth}
        y2={bodyBottom}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
    </g>
  );
}

DormStackableDrawersSchematic.supportsSideViews = true;
